import { FileSelectionField } from "./FileSelectionField";
import { RenderConfig } from "../core/form/ValidatedField";

export const ImageFileSelectionField = ({
	fieldName,
	fieldValue,
	updateField,
	onChange,
}: RenderConfig<string>) => (
	<FileSelectionField
		name={fieldName}
		selectedFileId={fieldValue}
		setSelectedFileId={updateField}
		filterByFileTypes={["image/png", "image/jpg", "image/jpeg"]}
		onChange={onChange}
	/>
);
